import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { NewdanhmucdangkiemAction } from 'src/actions/newdanhmucdangkiem.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getNewdanhmucdangkiemStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

import { isGrantPermission } from 'src/utils/utils';

const NewdanhmucdangkiemLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedNewdanhmucdangkiemIds, setSelectedNewdanhmucdangkiemIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.newdanhmucdangkiem);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(NewdanhmucdangkiemAction.updateFilter(payload));
    dispatch(NewdanhmucdangkiemAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedNewdanhmucdangkiemIds;

    if (event.target.checked) {
      newSelectedNewdanhmucdangkiemIds = items.map((newdanhmucdangkiem) => newdanhmucdangkiem.id);
    } else {
      newSelectedNewdanhmucdangkiemIds = [];
    }

    setSelectedNewdanhmucdangkiemIds(newSelectedNewdanhmucdangkiemIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedNewdanhmucdangkiemIds.indexOf(id);
    let newSelectedNewdanhmucdangkiemIds = [];

    if (selectedIndex === -1) {
      newSelectedNewdanhmucdangkiemIds = newSelectedNewdanhmucdangkiemIds.concat(selectedNewdanhmucdangkiemIds, id);
    } else if (selectedIndex === 0) {
      newSelectedNewdanhmucdangkiemIds = newSelectedNewdanhmucdangkiemIds.concat(selectedNewdanhmucdangkiemIds.slice(1));
    } else if (selectedIndex === selectedNewdanhmucdangkiemIds.length - 1) {
      newSelectedNewdanhmucdangkiemIds = newSelectedNewdanhmucdangkiemIds.concat(selectedNewdanhmucdangkiemIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedNewdanhmucdangkiemIds = newSelectedNewdanhmucdangkiemIds.concat(
        selectedNewdanhmucdangkiemIds.slice(0, selectedIndex),
        selectedNewdanhmucdangkiemIds.slice(selectedIndex + 1)
      );
    }

    setSelectedNewdanhmucdangkiemIds(newSelectedNewdanhmucdangkiemIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, newdanhmucdangkiem) => {
    setSelected(newdanhmucdangkiem);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(NewdanhmucdangkiemAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(NewdanhmucdangkiemAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: '500px', width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Sản phẩm
                </TableCell>
                <TableCell>
                  Số khung
                </TableCell>
                <TableCell>
                  Số máy
                </TableCell>
                <TableCell>
                  Ngày xuất xưởng
                </TableCell>
                <TableCell>
                  Ngày trả đăng kiểm
                </TableCell>
                <TableCell>
                  Màu sắc
                </TableCell>
                <TableCell>
                  Ấn chỉ
                </TableCell>
                <TableCell>
                  Ghi chú
                </TableCell>
                {(role.priority < 4) && <TableCell>
                  Chức năng
                </TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((newdanhmucdangkiem, index) => (
                newdanhmucdangkiem ? <TableRow
                  hover
                  key={newdanhmucdangkiem.id}
                  selected={selectedNewdanhmucdangkiemIds.indexOf(newdanhmucdangkiem.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {(() => {
                        const sp = newdanhmucdangkiem.newdanhmucsanpham_ref;
                        if (!sp) return null;

                        const ncc = sp.newdanhmucnhacungcap_ref;

                        return (
                          <>
                            <span style={{ fontWeight: "bold" }}>
                              {sp.ma} - {sp.ten}
                            </span>
                            <br />
                            {ncc ? `(${ncc.ma} - ${ncc.ten})` : ""}
                          </>
                        );
                      })()}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucdangkiem.so_khung}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucdangkiem.so_may}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucdangkiem.ngay_xuat_xuong ? moment(newdanhmucdangkiem.ngay_xuat_xuong).format('YYYY-MM-DD') : ''}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucdangkiem.ngay_tra_dang_kiem ? moment(newdanhmucdangkiem.ngay_tra_dang_kiem).format('YYYY-MM-DD') : ''}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucdangkiem.mau_sac}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucdangkiem.an_chi}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucdangkiem.ghi_chu}
                    </Typography>
                  </TableCell>
                  {(role.priority < 4) && <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(newdanhmucdangkiem.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, newdanhmucdangkiem)}>
                      <Trash2Icon color='red' />
                    </IconButton>
                  </TableCell>}
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default NewdanhmucdangkiemLookupDetail;
